import { makeListReducer, SORT_ORDER } from 'lib/list-helper/makeListReducer';

export const INSPECTION_PLANS_LIST_PAGE_ACTIONS = {
  USER_STARTS_EXPORT: 'USER_STARTS_EXPORT',
  APP_FINISHES_EXPORT: 'APP_FINISHES_EXPORT',
};

const REDUCER_CONFIG = {
  [INSPECTION_PLANS_LIST_PAGE_ACTIONS.USER_STARTS_EXPORT]: (state) => ({
    ...state,
    isPreparingExport: true,
  }),
  [INSPECTION_PLANS_LIST_PAGE_ACTIONS.APP_FINISHES_EXPORT]: (state) => ({
    ...state,
    isPreparingExport: false,
  }),
};

export const { reducer, initialState } = makeListReducer(REDUCER_CONFIG, {
  sortBy: 'id',
  sortOrder: SORT_ORDER.DESC,
  isPreparingExport: false,
});
